import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "../store";
import {PiercingBookingPage} from "../pages/PiercingBookingPage";
import {OnlineBookingPage} from "../pages/OnlineBookingPage";
import { LoginPage } from "../pages/LoginPage";

const COMPONENTS_MAP: Record<string, React.FC<any>> = {
  "react-app-booking-tattoo": OnlineBookingPage,
  "react-app-booking-piercing": PiercingBookingPage,
  "react-app-login": LoginPage,
};

/**
 * Attendre que wpReactConfig soit disponible (injecté par WordPress)
 */
function waitForWpReactConfig(timeout = 5000): Promise<any> {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();
    const checkConfig = () => {
      const config = (window as any).wpReactConfig;
      if (config) {
        resolve(config);
      } else if (Date.now() - startTime > timeout) {
        reject(new Error('wpReactConfig not found'));
      } else {
        setTimeout(checkConfig, 50);
      }
    };
    checkConfig();
  });
}

Object.entries(COMPONENTS_MAP).forEach(([tag, Component]) => {
  class ReactCustomElement extends HTMLElement {
    private root: ReactDOM.Root | null = null;

    connectedCallback() {
      // Attendre que wpReactConfig soit disponible
      waitForWpReactConfig()
        .then((config) => {
          const basename = config.basename || '/';
          this.mountComponent(basename);
        })
        .catch((error) => {
          console.error('Failed to mount React component:', error);
          this.mountComponent('/');
        });
    }

    private mountComponent(basename: string) {
      if (!this.root) {
        this.root = ReactDOM.createRoot(this);
      }
      this.root.render(
        <React.StrictMode>
          <Provider store={store}>
            <BrowserRouter basename={basename}>
              <Component />
            </BrowserRouter>
          </Provider>
        </React.StrictMode>
      );
    }

    disconnectedCallback() {
      if (this.root) {
        this.root.unmount();
      }
    }
  }
  if (!customElements.get(tag)) {
    customElements.define(tag, ReactCustomElement);
  }
});
